<div [formGroup]="enterReasonForm" *ngIf="!loadingRecords">
    <section class="reasons-form">
        <div class="workflow-section-heading">Reasons for Variance</div>
        <ng-container *ngIf="hasVarianceWarningMessages()">
            <div class="warning notification" *ngFor="let varianceWarning of getVarianceWarnings()">
                <span class="icon-notification"></span> {{ varianceWarning }}
            </div>
        </ng-container>
        <div class="form-group compact">
            <div class="display-label compact">Add New Reason</div>
            <select [formControlName]="getReasonControlName()" id="{{ getReasonControlName() }}" attr.aria-label="Variance Reason">
                <option *ngFor="let reason of reasonOptions" [value]="reason.id">{{ reason.reason }}</option>
            </select>
        </div>
        <div class="form-group compact">
            <textarea [formControlName]="getExplanationControlName()" id="{{ getExplanationControlName() }}" attr.aria-label="Variance Explanation"></textarea>
        </div>
        <div class="form-group compact">
            <button [disabled]="isReasonNotSelected" (click)="addReason()"><span class="icon-plus"></span> Add Reason</button>
            <button class="cancel" (click)="cancelReason()"><span class="icon-cancel"></span> Clear</button>
        </div>
        <table class="condensed" *ngIf="reasons.length" [formArrayName]="getListControlName()" id="{{ getListControlName() }}">
            <thead>
                <tr>
                    <th>Reason</th>
                    <th>Explanation</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let reasonRecord of reasons; let i=index;" class="new" [formGroupName]="i">
                    <ng-template [ngIf]="!reasonRecord.editing">
                        <td>{{ getReasonLabel(reasonRecord.varianceReasonId) }}</td>
                        <td>{{ reasonRecord.explanation }}</td>
                        <td>
                            <button class="compact link" (click)="editReason(i)"><span class="icon-pencil"></span> Edit</button>
                            <button class="compact link" (click)="deleteReason(i)"><span class="icon-bin"></span> Remove</button>
                        </td>
                    </ng-template>
                    <ng-template [ngIf]="reasonRecord.editing">
                        <td class="form-group compact">
                            <select attr.aria-label="Variance Reason" [formControlName]="getEditingReasonControlName()" id="{{ getEditingReasonControlName() }}">
                                <option [value]="reasonRecord.varianceReasonId"> {{ getReasonLabel(reasonRecord.varianceReasonId) }}</option>
                                <option *ngFor="let reason of reasonOptions" [value]="reason.id">{{ reason.reason }}</option>
                            </select>
                        </td>
                        <td class="form-group compact">
                            <textarea attr.aria-label="Explanation" [formControlName]="getEditingExplanationControlName()" id="{{ getEditingExplanationControlName() }}">
                                {{ reasonRecord.explanation }}
                            </textarea>
                        </td>
                        <td>
                            <button class="compact" (click)="applyReasonEdit(i)"><span class="icon-check"></span> Apply</button>
                            <button class="compact cancel" (click)="cancelReasonEdit(i)"><span class="icon-cross"></span> Cancel</button>
                        </td>
                    </ng-template>
                </tr>
            </tbody>
        </table>
        <div class="warning" *ngIf="!hasReasons() && hasVariance()">
            <span class="icon-warning2"></span> One or more reasons for variance are required.
        </div>
        <div class="warning" *ngIf="isVarianceReasonDuplicated">
            <span class="icon-warning2"></span> Duplicate variance reasons are not allowed.
        </div>
    </section>
    <section *ngIf="shiftRecord.costCenter.measures.length">
        <div class="workflow-section-heading">Measures</div>
        <div class="workflow-input" *ngFor="let measure of shiftRecord.costCenter.measures">
            <input 
                type="number" 
                min="0" 
                [attr.aria-label]="measure.label" 
                [formControlName]="getMeasureControlName(measure.id)"
                id="{{ getMeasureControlName(measure.id) }}"
                pattern="[0-9]{1,6}(\.[0-9]{0,2})?">
            <span class="display-label">{{ measure.factor }} {{ measure.displayUnits }}</span>
        </div>
    </section>
    <div class="warning info" *ngIf="enterByBlock && !hasCompleteStaffingPlan()">* The information recorded during the previous block is incomplete.  Please complete your missing shift block.</div>
    <div class="warning info" *ngIf="!enterByBlock && !hasCompleteStaffingPlan()">* The information recorded during the previous working day is incomplete.  Please complete your missing shift block.</div>
</div>
